import actionTypes from './GIPPMPMF01ActionType';

/**
 * 進捗管理登録
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 進捗管理初期を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getProgressManagementInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PROGRESS_MANAGEMENT_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_PROGRESS_MANAGEMENT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_PROGRESS_MANAGEMENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_PROGRESS_MANAGEMENT_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 進捗管理を更新するReducer
 * @param {*} state
 * @param {*} action
 */
export const saveProgressManagementInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_PROGRESS_MANAGEMENT_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.SAVE_PROGRESS_MANAGEMENT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.SAVE_PROGRESS_MANAGEMENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.SAVE_PROGRESS_MANAGEMENT_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
